/** Preserve report-specific Type columns, such as a settlement's type. */
export const REPORT_CLASSIFICATION_COLUMN_ALIASES: Record<string, string> = {
  "Matter Type": "Incident Type",
  "Case Type": "Incident Type",
};

/** Place a newly introduced claims column beside its incident classification. */
export const REPORT_CLASSIFICATION_COLUMN_ANCHORS: Record<string, string> = {
  "Claim Types": "Incident Type",
};

/** Approaching Statutes previously had neither classification column. */
export const APPROACHING_STATUTES_COLUMN_ANCHORS: Record<string, string> = {
  "Incident Type": "Matter",
  ...REPORT_CLASSIFICATION_COLUMN_ANCHORS,
};
